
import { useEffect, useRef, useState } from 'react';
import { UserDto } from '../../../../../../dtos';

import { useTypedSelector } from '../../../../../../hooks/useTypeSelector';

import UserControlsMenu from './menu/UserControlsMenu'

import './UserControls.scss'
import {ChangePasswordPopup} from "./menu/ChangePasswordPopup";

const UserControls: React.FC = () =>{

    const { data } = useTypedSelector((state) => state.auth);

    const [showMenu, setShowMenu] = useState(false);
    const [userName, setUserName] = useState('');
    const [isOpenChangePasswordPopup, setIsOpenChangePasswordPopup] = useState<boolean>(false)

    const ref = useRef(null);

    useEffect(() => {

        let userDtoStr = localStorage.getItem('userDto')

        if(userDtoStr){
            let userDto: UserDto = JSON.parse(userDtoStr);

            if(userDto.firstName && userDto.lastName) {
                let twoCharsName = userDto.firstName!.charAt(0) + userDto.lastName!.charAt(0);
                setUserName(twoCharsName);
            }
            else {
                setUserName('U');
            }
        }

    }, [data]);

    const openChangePasswordPopup = () => {
        setShowMenu(false);
        setIsOpenChangePasswordPopup(true);
    }



    return (
        <>
            <div className="user_control" ref={ref} onClick={() => setShowMenu(true)}>

                <p className="user_control_name">{ userName }</p>
                {
                    showMenu &&
                    <UserControlsMenu
                        // show={true}
                        target={ref}
                        onHide={() => setShowMenu(false)}
                        openChangePasswordPopup={openChangePasswordPopup}
                    />
                }
            </div>
            {
                isOpenChangePasswordPopup &&
                <ChangePasswordPopup
                    setIsOpenChangePasswordPopup={setIsOpenChangePasswordPopup}
                />
            }
        </>
    )
}

export default UserControls;